import { VW_BLUE, BORDER, cardStyle, sectionStyle, sectionTitleStyle } from './analyseShared'

function Gauge({ score }) {
  const n = Math.max(0, Math.min(100, Number(score) || 0))
  return (
    <div style={{ position: 'relative', width: 120, height: 120, margin: '0 auto' }}>
      <svg viewBox="0 0 120 120" style={{ transform: 'rotate(-135deg)' }}>
        <circle cx="60" cy="60" r="48" fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="10" strokeDasharray="226 302" />
        <circle
          cx="60"
          cy="60"
          r="48"
          fill="none"
          stroke={VW_BLUE}
          strokeWidth="10"
          strokeDasharray={`${(n / 100) * 226} 302`}
          strokeLinecap="round"
        />
      </svg>
      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 28,
          fontWeight: 300,
          color: '#fff',
        }}
      >
        {n}
      </div>
    </div>
  )
}

function PerfList({ title, items, variant }) {
  return (
    <div style={{ ...cardStyle, flex: 1, minWidth: 260 }}>
      <h3 style={{ fontSize: 13, fontWeight: 500, marginBottom: 14, color: 'var(--text-secondary)' }}>{title}</h3>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {(items || []).map((p) => (
          <li key={p.label} style={{ padding: '10px 0', borderBottom: BORDER, fontSize: 13 }}>
            <div style={{ fontWeight: 500 }}>{p.label}</div>
            <div style={{ fontSize: 12, color: 'var(--text-tertiary)', marginTop: 4 }}>
              Vous {p.votre_delai}j · Marché {p.marche_delai}j
              {variant === 'under' && p.suggestion ? ` · ${p.suggestion}` : ''}
            </div>
          </li>
        ))}
        {!(items || []).length && (
          <li style={{ fontSize: 12, color: 'var(--muted)' }}>Données insuffisantes pour ce classement.</li>
        )}
      </ul>
    </div>
  )
}

export function SectionBenchmarkingConcession({ data, loading, error }) {
  if (loading) {
    return (
      <section style={sectionStyle}>
        <h2 style={sectionTitleStyle}>4 — Benchmarking concession</h2>
        <p style={{ color: 'var(--muted)', fontSize: 13 }}>Chargement…</p>
      </section>
    )
  }
  if (error) {
    return (
      <section style={sectionStyle}>
        <h2 style={sectionTitleStyle}>4 — Benchmarking concession</h2>
        <p style={{ color: '#fca5a5', fontSize: 13 }}>{error}</p>
      </section>
    )
  }
  if (!data || data.error) {
    return (
      <section style={{ ...sectionStyle, borderBottom: 'none' }}>
        <h2 style={sectionTitleStyle}>4 — Benchmarking concession</h2>
        <p style={{ color: 'var(--muted)', fontSize: 13 }}>{data?.error || 'Compte sans stock lié.'}</p>
      </section>
    )
  }

  const sc = data.score || {}
  const cards = data.cards || {}

  return (
    <section style={{ ...sectionStyle, borderBottom: 'none', paddingBottom: 0 }}>
      <h2 style={sectionTitleStyle}>4 — Benchmarking concession</h2>

      <div style={{ ...cardStyle, marginBottom: 28, display: 'flex', flexWrap: 'wrap', gap: 32, alignItems: 'center' }}>
        <Gauge score={sc.valeur} />
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ fontSize: 11, color: 'var(--text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
            Performance globale
          </div>
          <div style={{ fontSize: 22, fontWeight: 300, color: '#fff', marginTop: 8 }}>
            {data.concession || 'Votre concession'} : {sc.valeur}/100
          </div>
          <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginTop: 8 }}>
            {sc.evolution_semaine >= 0 ? '+' : ''}
            {sc.evolution_semaine} vs semaine dernière · <strong>{sc.statut}</strong>
          </div>
        </div>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 16,
          marginBottom: 28,
        }}
      >
        <BenchCard title="Rotation" lines={[cards.rotation?.texte, `Marché : ${cards.rotation?.marche_jours}j en moyenne`]} />
        <BenchCard
          title="Pricing"
          lines={[
            cards.pricing?.texte,
            cards.pricing?.signal === 'premium'
              ? 'Positionnement premium'
              : cards.pricing?.signal === 'agressif'
                ? 'Positionnement agressif'
                : 'Dans la moyenne',
          ]}
        />
        <BenchCard
          title="Fraîcheur stock"
          lines={[cards.fraicheur?.texte, `${cards.fraicheur?.nb_plus_120j ?? 0} motos dépassent 120 jours`]}
        />
        <BenchCard
          title="Diversité"
          lines={[cards.diversite?.texte, `Concentration top 3 : ${cards.diversite?.concentration_top3_pct}%`]}
        />
      </div>

      <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
        <PerfList title="Surperformers" items={data.surperformers} variant="over" />
        <PerfList title="Underperformers" items={data.underperformers} variant="under" />
      </div>
    </section>
  )
}

function BenchCard({ title, lines }) {
  return (
    <div style={cardStyle}>
      <div style={{ fontSize: 11, color: 'var(--text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        {title}
      </div>
      {(lines || []).filter(Boolean).map((line, i) => (
        <p key={i} style={{ fontSize: 13, color: i === 0 ? '#fff' : 'var(--text-secondary)', margin: i === 0 ? '12px 0 6px' : '0 0 4px', fontWeight: i === 0 ? 300 : 400 }}>
          {line}
        </p>
      ))}
    </div>
  )
}
